export interface ICustomerReport {
  kundenLink: string;
  vorgangsTyp: string;
  dokumentTyp: string;
  dokumentUrl: string;
  versandArt: string;
  infoVonPortal: string;
  infoVonKunde: string;
  bestellnummer: string;
  bestellnummerGesperrt: string;
  bestellInformation: string;
  bestellZusatz: string;
  rechnungNummer: string;
  rechnungInformation: string;
  rechnungZusatz: string;
  datum: string;
}

export function constructDocuments(): Partial<ICustomerReport>[] {
  const customerReportRow: Partial<ICustomerReport>[] = []
  return customerReportRow;
}